import { ChangeValue } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";

import type { Axis } from "app/components/RankingAxis/types";

import { ItemTitle, ItemValue, TooltipItem } from "app/components/RankingAxis/Tooltip/styles";

type TooltipContentSchema = {
    data: Axis;
    granularity: BenchmarkGranularity;
};

const TooltipContent = ({ data, granularity }: TooltipContentSchema) => (
    <Flex>
        <TooltipItem>
            <ItemTitle>Domain</ItemTitle>
            <ItemValue>{data.name}</ItemValue>
        </TooltipItem>
        <TooltipItem>
            <ItemTitle>Rank</ItemTitle>
            <ItemValue>#{data.rank}</ItemValue>
        </TooltipItem>
        <TooltipItem>
            <ItemTitle>{granularity === BenchmarkGranularity.MONTHLY ? "MoM" : "WoW"}</ItemTitle>
            <ChangeValue
                value={`${data?.rankChange}`}
                isDecrease={data?.rankChange < 0}
            />
        </TooltipItem>
    </Flex>
);

export default TooltipContent;
